import { ref as s, readonly as t } from "vue";
/**
 * @copyright Copyright (c) 2023 Grigorii K. Shartsev <me@shgk.me>
 *
 * @author Grigorii K. Shartsev <me@shgk.me>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const n = 1024, i = n / 2, e = (r) => document.documentElement.clientWidth < r, o = s(e(n)), l = s(e(i));
window.addEventListener("resize", () => {
  o.value = e(n), l.value = e(i);
}, { passive: !0 });
function u() {
  return t(o);
}
function a() {
  return t(l);
}
const M = t(o);
export {
  n as MOBILE_BREAKPOINT,
  i as MOBILE_SMALL_BREAKPOINT,
  M as isMobileState,
  u as useIsMobile,
  a as useIsSmallMobile
};
